import {
  roomByStages,
  roomBySteps,
  roomByTypes,
  roomByAcceptanceStatuses,
  roomByAcceptanceDesks,
  roomByPorch,
  roomByNumber,
  roomByRecordDate,
  roomByAddressDdu,
  roomByNumberDdu,
  roomByFinishType,
} from '../../../../shared/configs/filterOptions';
import {
  booleanMap,
  searchParamKeys,
} from '../../../../shared/configs/searchParams';
import { filterTypes } from '../../../../shared/packages/filter';
import {
  toYesNo,
  toIntegerArray,
  asIs,
} from '../../../../shared/packages/searchParamsNormalizer';
import {
  roomByHasRelations,
  valueToContent as hasRelationValueToContent,
} from './hasRelation';
import {
  roomByRepeat,
  valueToContent as repeatValueToContent,
} from './isRepeat';
import {
  valueToContent as serviceValueToContent,
  roomByAcceptanceServices,
} from './service';

const noop = () => {};

export const filterNormalizers = {
  [searchParamKeys.roomsTableHasRelations]: toYesNo,
  [searchParamKeys.roomsTableType]: toIntegerArray,
  [searchParamKeys.roomsTableStage]: toIntegerArray,
  [searchParamKeys.roomsTableStep]: toIntegerArray,
  [searchParamKeys.roomsTableStatus]: toIntegerArray,
  [searchParamKeys.roomsTableService]: toIntegerArray,
  [searchParamKeys.roomsTableDesk]: toIntegerArray,
  [searchParamKeys.roomsTablePorch]: toIntegerArray,
  [searchParamKeys.roomsTableRepeat]: toYesNo,
  [searchParamKeys.roomsTableFlatNumber]: asIs,
  [searchParamKeys.roomsTableAddressDdu]: asIs,
  [searchParamKeys.roomsTableNumberDdu]: asIs,
  [searchParamKeys.roomsTableRecordDate]: asIs,
  [searchParamKeys.roomsTableFinishType]: toIntegerArray,
};

export const filterItemsConfig = {
  [searchParamKeys.roomsTableHasRelations]: {
    getValue: roomByHasRelations.extract,
    getContent: (room) => {
      const value = roomByHasRelations.extract(room);
      return hasRelationValueToContent[value];
    },
    initial: {
      data: [
        {
          value: booleanMap.no,
          content: hasRelationValueToContent[booleanMap.no],
        },
      ],
      ids: new Set([booleanMap.no]),
    },
  },

  [searchParamKeys.roomsTableType]: {
    getValue: roomByTypes.extract,
    getContent: (room) => room.typeName,
  },

  [searchParamKeys.roomsTableStage]: {
    getValue: roomByStages.extract,
    getContent: (room) => room.stageAddressLifeCycle.name,
  },

  [searchParamKeys.roomsTableStep]: {
    getValue: roomBySteps.extract,
    getContent: (room) => room.stepAddressLifeCycle.name,
  },

  [searchParamKeys.roomsTableStatus]: {
    getValue: roomByAcceptanceStatuses.extract,
    getContent: (room) =>
      room.recordInfo?.acceptanceStatusAddressLifeCycle?.name,
    initial: {
      data: [{ value: 0, content: 'Не установлено' }],
      ids: new Set([0]),
    },
  },

  [searchParamKeys.roomsTableFinishType]: {
    getValue: roomByFinishType.extract,
    getContent: (room) => room.addressTypeOfFinish?.name,
    initial: {
      data: [{ value: 0, content: 'Не указан' }],
      ids: new Set([0]),
    },
  },

  [searchParamKeys.roomsTableService]: {
    getValue: roomByAcceptanceServices.extract,
    getContent: (room) => {
      const id = roomByAcceptanceServices.extract(room);
      return serviceValueToContent[id];
    },
  },

  [searchParamKeys.roomsTableRecordDate]: {
    getValue: roomByRecordDate.extract,
    getContent: noop,
  },

  [searchParamKeys.roomsTableDesk]: {
    getValue: roomByAcceptanceDesks.extract,
    getContent: (room) => room.recordInfo?.acceptanceDesk?.name,
  },

  [searchParamKeys.roomsTablePorch]: {
    getValue: roomByPorch.extract,
    getContent: (room) => {
      const porch = roomByPorch.extract(room);
      return `${porch} подъезд`;
    },
  },

  [searchParamKeys.roomsTableRepeat]: {
    getValue: roomByRepeat.extract,
    getContent: (room) => {
      const value = roomByRepeat.extract(room);
      return repeatValueToContent[value];
    },
    initial: {
      data: [
        {
          value: booleanMap.no,
          content: repeatValueToContent[booleanMap.no],
        },
      ],
      ids: new Set([booleanMap.no]),
    },
  },
};

export const options = {
  [searchParamKeys.roomsTableHasRelations]: {
    type: filterTypes.byParam,
    extractor: roomByHasRelations,
  },
  [searchParamKeys.roomsTableType]: {
    type: filterTypes.byParam,
    extractor: roomByTypes,
  },
  [searchParamKeys.roomsTableStage]: {
    type: filterTypes.byParam,
    extractor: roomByStages,
  },
  [searchParamKeys.roomsTableStep]: {
    type: filterTypes.byParam,
    extractor: roomBySteps,
  },
  [searchParamKeys.roomsTableStatus]: {
    type: filterTypes.byParam,
    extractor: roomByAcceptanceStatuses,
  },
  [searchParamKeys.roomsTableService]: {
    type: filterTypes.byParam,
    extractor: roomByAcceptanceServices,
  },
  [searchParamKeys.roomsTableRecordDate]: {
    type: filterTypes.byParam,
    extractor: roomByRecordDate,
  },
  [searchParamKeys.roomsTableDesk]: {
    type: filterTypes.byParam,
    extractor: roomByAcceptanceDesks,
  },
  [searchParamKeys.roomsTablePorch]: {
    type: filterTypes.byParam,
    extractor: roomByPorch,
  },
  [searchParamKeys.roomsTableRepeat]: {
    type: filterTypes.byParam,
    extractor: roomByRepeat,
  },
  [searchParamKeys.roomsTableFlatNumber]: {
    type: filterTypes.bySearch,
    extractor: roomByNumber,
  },
  [searchParamKeys.roomsTableAddressDdu]: {
    type: filterTypes.bySearch,
    extractor: roomByAddressDdu,
  },
  [searchParamKeys.roomsTableNumberDdu]: {
    type: filterTypes.bySearch,
    extractor: roomByNumberDdu,
  },
  [searchParamKeys.roomsTableFinishType]: {
    type: filterTypes.byParam,
    extractor: roomByFinishType,
  },
};
